import React from 'react';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StyledRules } from './index.style';

const Rules = ({ referrerPointsTask, refereePointsTask }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const referralConfig = useSelector((state) => state.referralConfig);

  const { referrerPoints, refereePoints, charsPerPoint } = referralConfig || {};
  const referrerCharsReward = referrerPoints * charsPerPoint;
  const refereeCharsReward = refereePoints * charsPerPoint;

  const rules = {
    referralIntroDesc: {
      content: t('referralIntroDescV2', {
        referrerCharsReward: referrerCharsReward.toLocaleString(language),
        refereeCharsReward: refereeCharsReward.toLocaleString(language),
      }),
      open: true,
    },
    rule2: {
      content: t('rule2', {
        charsReward: (+refereePointsTask * charsPerPoint)?.toLocaleString(
          language,
        ),
        charsRewardIntroducer: (
          +referrerPointsTask * charsPerPoint
        )?.toLocaleString(language),
      }),
      open: true,
    },
    rule3: {
      content: t('rule3'),
      open: true,
    },
    rule4: {
      content: t('rule4'),
      open: true,
    },
  };

  return (
    <StyledRules>
      <Typography
        style={{ marginBottom: '8px ' }}
        variant="body-20-bold"
        color={COLOR.descriptionGray}
      >
        {t('rules')}
      </Typography>

      {Object.keys(rules)
        .filter((rule) => rules[rule].open)
        .map((rule, index) => (
          <Typography variant="body-14-regular" color={COLOR.descriptionUpload}>
            {index + 1}.{' '}
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: rules[rule].content,
              }}
            />
          </Typography>
        ))}
    </StyledRules>
  );
};

export default Rules;
